<template>
  <div id="app">
    <NavBar v-if="isAuth"></NavBar>
    <router-view/>
  </div>
</template>

<script>
import NavBar from "./components/layout/Navbar";
import cookie from "vue-cookie";
import Users from "@/services/Users";
export default {
  data() {
    return {
      id: ""
    };
  },
  components: {
    NavBar
  },
  mounted() {
    this.checkAuth();
    if(process.env.VUE_APP_TITLE)
      document.title = process.env.VUE_APP_TITLE;
  },
  computed: {
    isAuth() {
      return this.$store.getters.ISAUTH;
    }
  },
  methods: {
    checkAuth() {
      if (!this.$store.getters.ISAUTH) {
        if (
          cookie.get("mgc-u-id") != "" &&
          cookie.get("mgc-u-id") != null &&
          cookie.get("mgc-authToken") != "" &&
          cookie.get("mgc-authToken") != null
        ) {
          this.logIn(cookie.get("mgc-u-id"));
        }
      }
    },
    logIn(userid) {
      //store date in Vuex
      this.storeUser(userid);
    },
    getProfile(id, cb) {
      Users.getProfile(id).then(res => {
        cb(res.data);
      });
    },
    storeUser(id) {
      Users.getUserById(id).then(res => {
        this.$store.commit(
          "STORE_NAME",
          res.data["first-name"] + " " + res.data["name"]
        );
        this.getProfile(res.data["user-profile-id"], cb => {
          this.$store.commit("LOG_IN");
          this.$store.commit("STORE_USERPROFILE", cb);
          //this.$router.push("/");
        });
      });
    }
  }
};
</script>